import { useQuery } from '@tanstack/react-query';

import decodeJson from '@seccon/shared/utils/decodeJson';
import ApiError from '@seccon/shared/utils/ApiError';

const EMPTY_ARRAY = [];

/**
 * Fetches the contract information
 * @param {} context - react query context
 * @returns {Promise<object>} - CurrentUser information
 */

function fetchOtherFacilities (reportId) {
  return fetch(`/foreignTravel/incident/${ reportId }/getOtherFacilitiesDropdownOptions`)
    .then(decodeJson)
    .catch(({ body, status }) => {
      if (status === 404) {
        throw new ApiError('Unable to get the other personnels');
      }
      throw new ApiError(body ? `Error: ${ body }` : 'Unable to retrieve other facilities. Please reload the page and try again');
    });
}

const useOtherFacilities = (reportId, shouldLoad) => {
  const { data } = useQuery({
    queryKey: ['useOtherFacilities', reportId],
    queryFn: () => fetchOtherFacilities(reportId),
    select: (response) => response?.otherFacilitiesDropdownOptionsList?.map((entry) => ({
      ...entry,
      fullName: `(${ entry.facilityCode }) ${ entry.facilityName }`
    })),
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    enabled: !!reportId && shouldLoad
  });

  return data ?? EMPTY_ARRAY;
};

export default useOtherFacilities;
